import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import { useOutsideClick, useSetState } from '@campaignhub/react-hooks'

import { Button, Box, FormField, Text } from '@campaignhub/suit-theme'

import custom from '@styles/custom.module.scss'

import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import useCurrentUser from '@hooks/useCurrentUser'

import { dateToFilter } from '@functions/dateToFilter'
import { filterToDate } from '@functions/filterToDate'

const defaultState = {
  dateEnd: new Date(),
  dateStart: new Date(),
  showFilter: false,
}

const DateFilter = (props) => {
  const { setJobState, jobState } = props
  const { dateFilter } = jobState

  const [state, setState] = useSetState(defaultState)
  const { dateEnd, dateStart, showFilter } = state

  const contentEl = useRef()
  const [isClickedOutside, setIsClickedOutside] = useOutsideClick(contentEl, { enabled: showFilter })

  const { currentUser: { timeZone } } = useCurrentUser()

  useEffect(() => {
    if (isClickedOutside && showFilter){
      setState({ showFilter: !showFilter })
      setIsClickedOutside(false)
    }
  }, [isClickedOutside])

  useEffect(() => {
    setState({
      dateStart: filterToDate(dateFilter.filterStart, 'start'),
      dateEnd: filterToDate(dateFilter.filterEnd, 'end'),
    })
  }, [dateFilter])

  const setCustomDateFilter = (startDate, endDate) => {
    setJobState({
      dateFilter: {
        filterStart: dateToFilter(startDate, 'start', timeZone),
        filterEnd: dateToFilter(endDate, 'end', timeZone),
      },
    })
  }

  const setDateFilter = (startDate, endDate) => {
    setJobState({
      dateFilter: {
        filterStart: startDate,
        filterEnd: endDate,
      },
    })
  }

  return (
    <FormField direction="column" boxProps={{ paddingBottom: 'medium', width: ['100%', '400px'] }}>
      <Box className={custom.root} ref={contentEl}>
        <select
          onMouseDown={(e) => {
            e.preventDefault()
            setState({ showFilter: !showFilter })
          }}
          defaultValue="Date Range"
        >
          <option>Date Range</option>
        </select>

        {showFilter && (
          <Box className={custom.popup}>
            <Box flexDirection="column" maxHeight="290px" overflowY="auto">
              <Box flexDirection="row" marginBottom="medium">
                <Box flexDirection="column" marginRight="medium">
                  <Text color="bodyFontLightColor" fontSize="xsmall" paddingBottom="small">From</Text>
                  <DatePicker selected={dateStart} onChange={date => setCustomDateFilter(date, dateEnd)} dateFormat="dd MMM yyyy" maxDate={dateEnd} />
                </Box>
                <Box flexDirection="column" marginRight="medium">
                  <Text color="bodyFontLightColor" fontSize="xsmall" paddingBottom="small">To</Text>
                  <DatePicker selected={dateEnd} onChange={date => setCustomDateFilter(dateStart, date)} dateFormat="dd MMM yyyy" minDate={dateStart} />
                </Box>
              </Box>
              <Button
                buttonStyle="secondary"
                size="medium"
                marginBottom="medium"
                fontWeight="light"
                onClick={() => setDateFilter('0d', '1d')}
              >
                Today
              </Button>
              <Button
                buttonStyle="secondary"
                size="medium"
                marginBottom="medium"
                fontWeight="light"
                onClick={() => setDateFilter('-1d', '0d')}
              >
                Yesterday
              </Button>
              <Button
                buttonStyle="secondary"
                size="medium"
                marginBottom="medium"
                fontWeight="light"
                onClick={() => setDateFilter('0m', '1m')}
              >
                This Month
              </Button>
              <Button
                buttonStyle="secondary"
                size="medium"
                marginBottom="medium"
                fontWeight="light"
                onClick={() => setDateFilter('-1m', '0m')}
              >
                Past Month
              </Button>
              <Button
                buttonStyle="secondary"
                size="medium"
                marginBottom="medium"
                fontWeight="light"
                onClick={() => setDateFilter('', '')}
              >
                Reset
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </FormField>
  )
}

DateFilter.propTypes = {
  setJobState: PropTypes.func,
  jobState: PropTypes.object,
}

export default DateFilter
